import Icon from '@/shared/components/Icon/Icon';
import { MarketInfo } from '@cex/shared-modules';
import { IonLabel, IonRow } from '@ionic/react';
import styles from './MarketListItem.module.css';
import { getAssetName } from '@/shared/helpers/assets';
import { useGetTradingviewQuery } from '@/features/tradingview/tradingviewApi';
import { getTradingviewSymbol } from '@/shared/helpers/markets';
import { useMemo } from 'react';
import { getEuroFormat, getPercentFormat } from '@/shared/helpers/formatters';

type MarketListItemProps = {
  market: MarketInfo;
};

const getTrend = (priceChange: number): 'up' | 'down' | 'neutral' => {
  if (priceChange > 0) {
    return 'up';
  }

  if (priceChange < 0) {
    return 'down';
  }

  return 'neutral';
};

const MarketListItem: React.FC<MarketListItemProps> = ({ market }) => {
  const { basicCode } = market;
  const marketId = `${basicCode}-eur`;

  const date = new Date();
  const now = Math.floor(date.getTime() / 1000);
  const oneDayAgo = now - 24 * 3600;

  const { data: tvData } = useGetTradingviewQuery({
    ticker: marketId,
    symbol: getTradingviewSymbol(market),
    resolution: '15',
    from: oneDayAgo,
    to: now
  });

  const chartData = useMemo(() => {
    return tvData?.entities[marketId]?.chartData || null;
  }, [marketId, tvData]);

  const firstPrice = chartData ? chartData[0].value : 0;
  const lastPrice = chartData?.slice(-1)[0].value;
  const priceChange = lastPrice - firstPrice;
  const priceChangePercent = priceChange !== 0 ? priceChange / firstPrice : 0;
  const trend = getTrend(priceChange);

  return (
    <>
      <IonRow>
        <span className={styles.marketWrapper}>
          <Icon size="large" color={basicCode} src={`assets/icons/${basicCode}.svg`} className={styles.icon} />
          <IonLabel>
            {getAssetName(basicCode)}&nbsp;
            <small className={styles.assetBaseId}>{basicCode.toUpperCase()}</small>
          </IonLabel>
        </span>
      </IonRow>
      <IonRow>
        <div className={`${styles.priceWrapper}`}>
          <span> {getEuroFormat(lastPrice)} </span>
          <span className={`${styles.percentage} ${styles[trend]}`}>{getPercentFormat(priceChangePercent)}</span>
        </div>
      </IonRow>
    </>
  );
};

export default MarketListItem;
